import { render, staticRenderFns } from "./IPSProfile.vue?vue&type=template&id=1bfe99cc&scoped=true&"
import script from "./IPSProfile.vue?vue&type=script&lang=js&"
export * from "./IPSProfile.vue?vue&type=script&lang=js&"
import style0 from "./IPSProfile.vue?vue&type=style&index=0&id=1bfe99cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe99cc",
  null
  
)

export default component.exports